import type { RootState } from 'application/store';
import { ICreatePointsGroupState } from './types';

export const selectCreatePointsGroup = (state: RootState): ICreatePointsGroupState => state?.createPointsGroup;

export const selectTitle = (state: RootState): string => state.createPointsGroup.title;

export const selectDevices = (state: RootState) => state.createPointsGroup.devices;

export const selectDevicesCount = (state: RootState): number => state.createPointsGroup.devices?.length ?? 0;

export const selectMasterVideoStream = (state: RootState) => state.createPointsGroup.masterVideoStream;

export const selectIsValid = (state: RootState): boolean =>
  !!(state.createPointsGroup.title && state.createPointsGroup.devices && state.createPointsGroup.devices.length > 0);

export const selectStep = (state: RootState) => state.createPointsGroup.step;
